module.exports = __webpack_public_path__ + "img/sunshine_320.87493e8d.png";